import { render, staticRenderFns } from "./TodayReservationsPage.vue?vue&type=template&id=2084f1c4&scoped=true"
import script from "./TodayReservationsPage.vue?vue&type=script&lang=js"
export * from "./TodayReservationsPage.vue?vue&type=script&lang=js"
import style0 from "./TodayReservationsPage.vue?vue&type=style&index=0&id=2084f1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084f1c4",
  null
  
)

export default component.exports